import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';

// Shared shell for simple content pages (About, Services, Help Center).
const SimplePage = ({ title, subtitle, children }) => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900">
    <header className="border-b border-cyan-300/20 bg-gray-900/50 backdrop-blur-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <Shield className="h-8 w-8 text-cyan-400" />
            <span className="text-xl font-bold text-white">CyberGuard Global</span>
          </Link>
          <Link to="/" className="flex items-center space-x-2 text-gray-400 hover:text-cyan-400 transition-colors">
            <ArrowLeft className="h-5 w-5" />
            <span>Back to Home</span>
          </Link>
        </div>
      </div>
    </header>

    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{title}</h1>
          {subtitle && <p className="text-xl text-gray-300">{subtitle}</p>}
        </div>
      </div>
    </section>

    <main className="container mx-auto px-4 pb-16">
      <div className="max-w-4xl mx-auto space-y-8">{children}</div>
    </main>

    <footer className="border-t border-cyan-300/20 bg-gray-900/50">
      <div className="container mx-auto px-4 py-8 text-center text-gray-400 text-sm space-x-4">
        <span>© {new Date().getFullYear()} CyberGuard Global</span>
        <Link to="/privacy-policy" className="hover:text-cyan-400">Privacy Policy</Link>
        <Link to="/terms-of-service" className="hover:text-cyan-400">Terms of Service</Link>
        <Link to="/contact" className="hover:text-cyan-400">Contact</Link>
      </div>
    </footer>
  </div>
);

export const Card = ({ title, children }) => (
  <div className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 border border-cyan-300/30 rounded-lg p-6 md:p-8">
    {title && <h2 className="text-2xl font-bold text-white mb-4">{title}</h2>}
    <div className="text-gray-300 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default SimplePage;
